// 📁 src/components/OtherZens.jsx
import { useEffect, useState, useContext } from "react";
import { loadZens } from "../data/loadZens";
import ZenCard from "./ZenCard";

import UnderlineSketch from "./UnderlineSketch";
import { NameContext } from "../context/NameContext";



export default function ZenListZen({ currentSlug, max = 3 }) {
  const [zens, setZens] = useState([]);
  const [loading, setLoading] = useState(true);
  const { name } = useContext(NameContext);


  useEffect(() => {
    loadZens().then((data) => {
      const filtered = data.filter(zen => zen.slug !== currentSlug);
      setZens(filtered);
      setLoading(false);
    });
  }, [currentSlug]);

  if (loading) return <div className="py-10 text-center font-mono text-xs text-[#EFEBDC]0">Lade weitere ZenDev Beiträge…</div>;
  if (!zens.length) return null;

  return (
   <div className="mt-16 p-4 max-w-4xl mx-auto">
        <div className="py-10">
       
        </div>
      <h3 className="font-mono text-xs text-brand mb-6 text-center sm:text-left">Weitere ZenDev für Dich {name}</h3>
      <div className="grid gap-6 sm:grid-cols-2">
         {zens.slice(0, max).map(zen => (
          <ZenCard zen={zen} key={zen.slug} />
        ))}
      </div>
      <div className="py-10">
      <UnderlineSketch></UnderlineSketch></div>
    </div>

  );
}
